<template lang="pug">
section.wrapper
    .deliverystatus-container.px-4.mt-4(v-if='!loading')
        .section-header-left
            h1.text-black.header-title.py-2.fw-500 
                | {{ $t("deliveryStatus.titlePage") }}
                span.text-danger(v-if='info.old_order_from') {{ $t("deliveryStatus.orderChangeStore")}}
        .row
            .col-12
                .p-relative
                    h5.text-black.fw-700.mb-2.text-danger(v-if='info.old_store_name')
                        del {{ info.old_store_name }} 
                    h5.text-black.fw-600.text-danger(v-if='info.old_order_from')
                        b-icon.mr-2.ml-2(icon='geo-alt')
                        del {{ info.old_order_from }}
                    h5.text-black.fw-700.mb-2
                        | {{ info.new_store_name }} 
                    h5.text-black.fw-600.mb-2
                        b-icon.mr-2.ml-2(icon='geo-alt')
                        | {{ info.order_from }}
                    h5.text-black.fw-600.mb-2
                        | {{ $t("deliveryInfo.estimatedDeliveryTime") }}: {{ info.isasap ? '(ASAP) --' : '' }} {{ info.servs_time }}
                    span
                    .repay-container(v-if='!isPaymentSuccess')
                        .message
                            p
                                i {{ $t("handleError.paymentNotCompleted") }}
                            h3 {{ message }}
                        button.back-btn.btn-first.btn-dark.fw-500.mt-3(@click='payAgain()')
                            | {{ $t("button.payAgain") }}
                    div(v-else='')
                        div#add-listing-tab.step-app(v-if='!isCancelled')
                            .progress-bar-status.row
                                .static(:class="['col-' + statuses.findIndex((item) => item.name == info.status) * 3]")
                                .animation.col-3(v-if="info.status != 'completed'")
                            ul.step-steps
                                li(v-for='(item, index) of statuses' :key='index' :class='item.status')
                                    span.fa-stack.fa-2x.icon
                                        i.fa.circle.fa-circle.fa-stack-lg
                                        i.fa.check.fa-check.fa-stack-1x.fa-inverse
                                    a
                                        span.step-name
                                            | {{ $t('deliveryStatus.' + item.name) }}
                                            br
                                            template(v-if="item.name === 'orderSent'")
                                                | {{ info.start_time_payment | formatTime }}
                        .text-center.py-5(v-if='isCancelled')
                            h3.text-red {{ $t("deliveryStatus.cancelled") }}
        hr
        .row.w-100(v-if='!info.recipient_phone')
            .col-12.deliver-to
                h5.text-black.fw-600.mb-2
                    | {{ info.pick_up_at_store ? $t('deliveryStatus.pickUpAtStore') : $t('deliveryStatus.deliveryTo') }}
                p.text-black.m-0.fw-400 {{ info.delivery_to }}
                p.text-black.m-0.fw-400 {{ info.delivery_address_note }}
                p.text-black.m-0.fw-400 {{ $t("deliveryInfo.name") }}: {{ info.name }}
                p.text-black.m-0.fw-400 {{ $t("deliveryInfo.phoneNumber") }}: {{ info.phone }}
                p.text-black.m-0.fw-400(v-if="info.email !== ''") {{ $t("auth.email") }}: {{ info.email }}
                p.text-black.m-0.fw-400(v-if="info.instructions !== ''") {{ $t("deliveryStatus.deliveryInstructions") }}: {{ info.instructions }}
        .row.w-100(v-if='info.recipient_phone')
            .col-12.deliver-to
                p.text-black.fw-600.mb-2.deliver-to
                    | {{ info.pick_up_at_store ? $t('deliveryStatus.pickUpAtStore') : $t('deliveryStatus.deliveryTo') }}
                p.text-black.m-0.fw-400 {{ info.recipient_address }}
                p.text-black.m-0.fw-400 {{ info.delivery_address_note }}
                p.text-black.m-0.fw-400 {{ $t("deliveryInfo.name") }}: {{ info.recipient_name }}
                p.text-black.m-0.fw-400 {{ $t("auth.phoneNumber") }}: {{ info.recipient_phone }}
                p.text-black.m-0.fw-400(v-if="info.email !== ''") {{ $t("auth.email") }}: {{ info.pick_up_at_store ? info.recipient_email : info.email  }}
                p.text-black.m-0.fw-400(v-if="info.instructions !== ''") {{ $t("deliveryStatus.deliveryInstructions") }}: {{ info.instructions }}
        hr.mt-4
        .w-100.row
            .col-12
                p.title.text-light-white
                    span.text-black
                        | {{ $t("deliveryInfo.yourOrderNo") + ": " }}
                        b {{ "#" + info.order_no }}
            .col-12.mt-4(v-for='(item) of foods' :key='item.menucd')
                .checkout-product(v-if='item.meisaikb == 0')
                    .ordered-menu
                        .product-img
                            a
                                img(:src='item.image' alt='#' @error='setErrorImg')
                        div.quantity
                            span.text-black {{ item.quantity }}
                        div(:title='item.menunm')
                            h5 {{ item.menunm }}
                            span.product-topping {{ item.toppingName }}
                    .product-price
                        span.text-light-white {{ (Number(item.amount)) | formatCurrency }}
        .confirm-monetary
            .price-table
                .item
                    h4.text-black.fw-500.m-0 {{ $t("deliveryInfo.paymentMethod") }}
                    h4.text-black.fw-500.m-0 {{ info.e_money_type | formatEMoney }}
                .line-dash-light.mt-4

                div(v-if='info.crm_promotion_amount > 0')
                    h4.text-black.fw-500.pb-4.mt-4 {{ $t("deliveryInfo.originalBill") }}
                    .item
                        p.text-black.m-0 {{ $t("deliveryInfo.subTotal") }}
                        p.text-black.m-0 {{ (info.sub_total) | formatCurrency }}
                    .item
                        p.text-red.m-0 {{ $t("promotion.discount") }}
                        p.text-red.m-0 {{ '-' }} {{ (info.crm_promotion_amount) | formatCurrency }}

                div(v-if='info.crm_promotion_amount > 0')
                    .line-dash-light.mt-4
                    h4.text-black.fw-500.pb-4.mt-4(v-if='info.crm_promotion_amount > 0') {{ $t("deliveryInfo.discountedBill") }}
                .item(:class='info.crm_promotion_amount > 0 ? "" : "mt-4"')
                    p.text-black.m-0 {{ $t("deliveryInfo.subTotal") }}
                    p.text-black.m-0 {{ (info.after_promotion_subtotal) | formatCurrency }}
                .item(v-for='(tax, index) in tax_rate'  v-if='vats[index] > 0')
                    p.text-black.m-0 {{ $t("deliveryInfo.vat") + '(' + tax + '%) ' }}:
                    p.text-black.m-0 {{ (vats[index]) | formatCurrency }}
                .item(v-if='info.coupon > 0')
                    p.text-red.m-0 {{ $t("promotion.cashVoucher") }}
                    p.text-red.m-0 {{ '-' }} {{ (info.coupon) | formatCurrency }}

                div(v-if='!info.pick_up_at_store  && info.delivery_fee')
                    .item
                        p.text-black.m-0 {{ $t("Delivery fee") }}
                        p.text-black.m-0 {{ (info.delivery_fee) | formatCurrency }}

            .total-price
                h3.title.text-black {{ $t("deliveryInfo.total") }}
                h2.title.text-black {{ (info.after_promotion_total) | formatCurrency }}

        button.back-btn.button--secondary(@click='back()')
            | {{ $t("button.back") }}
    loader(v-show='loading')

</template>
<script>
import Cookies from "js-cookie";
import CustomerAPI from "@/api/customer";
import { mapGetters } from "vuex";
import moment from "moment";
import commonFunc from "@/common/commonFunc";
import Constants from "@/common/constant";
import Loader from "@/components/common/Loader.vue";
import popup from "@/components/mixins/popup";
import store from "@/store/store";

export default {
    name: "DeliveryStatus",
    components: {
        Loader,
    },
    props: {
        errormsg: {
            type: String,
            required: false,
        },
    },
    mixins: [popup],
    beforeRouteEnter(to, from, next) {
        window.scrollTo(0, 0);
        store.state.auth.allowAnonymous = false;
        store.state.auth.isConfirmScreen = false;
        store.state.auth.isFromMenuScreen = false;
        next();
    },
    beforeRouteLeave(to, from, next) {
        clearInterval(this.stateInterval);
        store.state.auth.allowAnonymous = false;
        next();
    },

    filters: {
        formatTime(value) {
            if (value == undefined || value == "") return "";
            return moment(String(value)).format("HH:mm");
        },
        formatDate(value) {
            return commonFunc.formatDate(value);
        },
        formatEMoney(value) {
            if (value == undefined || value == "") return "Cash";
            switch (value) {
                case Constants.MONEY_TYPE_CASH:
                    return "Cash";
                case Constants.MONEY_TYPE_MOMO:
                    return "Momo";
                case Constants.MONEY_TYPE_PAYOO:
                    return "Payoo";
            }
        },
    },

    data: function () {
        return {
            orderNo: null,
            info: {},
            foods: [],
            statuses: [
                {
                    name: "orderSent",
                    status: "active",
                },
                {
                    name: "accepted",
                    status: "",
                },
                {
                    name: "cooking",
                    status: "",
                },
                {
                    name: "ready",
                    status: "",
                },
                {
                    name: "completed",
                    status: "",
                }
            ],
            stateInterval: null,
            loading: true,
            deliveryFeeAmount: 0,
            isCancelled: false,
            paymentStatus: '',
            message: '',
            tax_rate: [],
            vats: [],
            newStoreName: null,
        };
    },

    computed: {
        ...mapGetters({
            appSetting: "settingGet",
            appMisc: "miscGet"
        }),

        isPaymentSuccess() {

            if (this.info.e_money_type == Constants.MONEY_TYPE_CASH) return true;

            if (Constants.PAYMENT_STATUS.UNPAID == this.paymentStatus) {
                if (this.appMisc.errormsg === "") return true;
                if (this.appMisc.errormsg !== '') return false;
            }

            if (Constants.PAYMENT_STATUS.SUCCESS.indexOf(this.paymentStatus.toLowerCase()) === -1) {
                return false;
            }

            if (Constants.PAYMENT_STATUS.FAIL.indexOf(this.paymentStatus.toLowerCase()) !== -1) {
                return false;
            }

            return true;
        }

    },

    watch: {
        $route(to, from) {
            if (to != from && to.name === 'DeliveryStatus') {
                clearInterval(this.stateInterval);
                this.getOrder();
            }
        },
    },

    async created() {
        this.orderNo = this.$route.query.orderNo;
        this.message = this.appMisc.errormsg;
        this.$store.commit("cartSetIsShow", false);
        this.getOrder();
    },

    mounted() {
        this.$root.$on("changeLanguage", (language) => {
            if (!language) return;
            this.$store.dispatch("getMenuLanguage", language);
        });

    },

    methods: {
        generateToppingName(food) {
            if (food.length === 0) return;
            food.forEach(function (x) {
                if (x.topping.length > 0) {
                    x["toppingName"] = "";
                    for (let i = 0; i < x.topping.length; i++) {
                        if (x.topping[i].quantity > 1) {
                            x["toppingName"] += `(${x.topping[i].quantity}x) `;
                        }
                        x["toppingName"] += x.topping[i].menunm;
                        if (i < x.topping.length - 1) {
                            x["toppingName"] += "\n";
                        }
                    }
                }
            });
        },

        // Order
        getOrder() {
            this.loading = true;
            if (!this.orderNo) {
                this.$bvModal.msgBoxOk(this.$t("handleError.idError"), this.messageBoxOK);
            }

            CustomerAPI.getDeliveryInfoByOrderNo({ order_no: this.orderNo })
                .then((res) => {
                    this.info = res.data.data.info;
                    this.foods = res.data.data.food;
                    this.generateToppingName(this.foods);
                    this.updateStatus(this.info.status);
                    this.paymentStatus = this.info.payment_status;
                    this.deliveryFeeAmount = this.info.delivery_fee;
                    this.tax_rate = [];
                    this.info.multi_tax?.split(";").forEach(item => {
                        let mt = item.split(":")
                        this.tax_rate.push(mt[0])
                        this.vats.push(mt[1])
                    });
                    this.showWarningStoreChange();

                    // recall every 1 minute
                    this.observeOrder({ order_no: this.orderNo });
                })
                .catch((err) => {
                    this.$bvModal.msgBoxOk(this.$t("handleError.loadDeliveryInforError"), this.messageBoxOK);
                }).finally(() => {
                    this.loading = false;
                });
        },

        //Handle status bar order
        updateStatus(status) {
            this.isCancelled = ['canceled', 'cancelled'].indexOf(status) !== -1;
            let indexStatus = this.statuses.findIndex((item) => item.name == status);

            for (let i = 0; i < this.statuses.length; i++) {
                if (i <= indexStatus) {
                    this.statuses[i].status = "done";
                } else {
                    this.statuses[i].status = "";
                }
            }
        },

        observeOrder(orderNo) {
            let self = this;
            this.stateInterval = setInterval(() => {
                CustomerAPI.getDeliveryInfoByOrderNo(orderNo)
                    .then((res) => {
                        self.info = res.data.data.info;
                        self.foods = res.data.data.food;
                        self.generateToppingName(self.foods);
                        self.updateStatus(self.info.status);
                        self.paymentStatus = self.info.payment_status;
                        self.deliveryFeeAmount = self.info.delivery_fee;
                        self.tax_rate = [];
                        self.info.multi_tax?.split(";").forEach(item => {
                            let mt = item.split(":")
                            self.tax_rate.push(mt[0])
                            self.vats.push(mt[1])
                        });
                        this.showWarningStoreChange();
                    })
                    .catch((err) => {
                        console.log(err);
                    });
            }, 1000 * 60 * Constants.MINUTES_UPDATE_ORDER_STATUS);
        },

        showWarningStoreChange () {
            let {
                new_store_name: newStoreName, 
                old_store_name: oldStoreName,
                status,
            } = this.info;
            if (!this.newStoreName && oldStoreName && status != 'completed') {
                this.newStoreName = newStoreName;
                this.$bvModal.msgBoxOk(
                    this.$t("deliveryStatus.message-changeStore", { name: newStoreName }),
                    {...this.messageBoxAttention, html: true},
                );
            }
        },

        /**
         * Format currency
         */
        async payAgain() {
            this.loading = true;
            const paymentObject = Object.freeze({
                amount: this.info.afterPromotion.total,
                ship_date: moment(this.info.servsTime).format('DD/MM/YYYY'),
                order_id: this.info.orderNo,
                store_name: this.info.storeName
            });

            const { data } = await CustomerAPI.getPayooGateway(paymentObject).catch(err => {
                this.loading = false;
                this.$bvModal.msgBoxOk(this.$t("handleError.paymentURL"), this.messageBoxOK);
                console.log(err);
                return;
            });

            if (data.payment_url) {
                data.payment_url += this.appMisc.language.toLowerCase() == 'vi' ? '&locale=vi_VN' : '&locale=en_US';
                window.location.href = data.payment_url;
            }
        },

        back() {
            if (this.$store.state.auth.customer) {
                return this.$router.push("/order-history/");
            }
            return this.$router.push("/");
        },
    },
};
</script>

<style lang="scss">
</style>
